import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'customFeeRequired',
    'customFeeBlock',
    'tipBlock',
    'autoTipRequired',
    'tipType',
    'tipAmount',
    'tipPercent'
  ];

  connect() {
    this.handleCustomFeeRequiredChanged();
    this.handleAutoTipRequiredChanged();
  }

  handleCustomFeeRequiredChanged = () => {
    if (this.customFeeRequiredTarget.checked) this.customFeeBlockTarget.classList.remove('hidden');
    else this.customFeeBlockTarget.classList.add('hidden');
  }

  handleTipTypeChanged = () => {
    if (this.tipTypeTarget.value === 'amount') this.displayTipFlatAmount()
    else if (this.tipTypeTarget.value === 'percent') this.displayTipPercent()
    else this.hideTip();
  }

  handleAutoTipRequiredChanged = () => {
    if (this.autoTipRequiredTarget.checked) this.tipBlockTarget.classList.remove('hidden');
    else this.tipBlockTarget.classList.add('hidden');
    this.handleTipTypeChanged();
  }

  hideTip() {
    this.tipPercentTarget.classList.add('hidden');
    this.tipAmountTarget.classList.add('hidden');
  }

  displayTipFlatAmount() {
    this.tipAmountTarget.classList.remove('hidden');
    this.tipPercentTarget.classList.add('hidden');
  }

  displayTipPercent() {
    this.tipAmountTarget.classList.add('hidden');
    this.tipPercentTarget.classList.remove('hidden');
  }
}
